module.exports = __webpack_public_path__ + "img/alex.bd696231.svg";